module.exports = __webpack_public_path__ + "img/pattern2.36f0e1b.svg";